/*
 * CHPO styling for the Shopify Forms pop-up and its "Get 10% off" teaser.
 * Shopify Forms renders in an open shadow DOM, which page CSS cannot reach, so
 * this adds one stylesheet inside it. Colours and fonts come from the CSS
 * variables set in chpo-apps.css. Shopify Forms' class names carry build
 * hashes (for example _textHeading_2aowh_35), so rules match the stable part
 * of the name only. If Shopify renames a class, that rule simply stops
 * applying and the form falls back to its own look.
 */
(function () {
  if (window.chpoFormsStyled) return;
  window.chpoFormsStyled = true;

  var CSS = [
    '[class*="_formContainer_"] { border-radius: 0 !important; }',
    '[class*="_textHeading_"] { font-weight: 400 !important; line-height: 1.12 !important; letter-spacing: -0.02em !important; margin: 0 0 12px !important; }',
    '[class*="_textBody_"], [class*="_textBody_"] p { font-size: 15px !important; line-height: 24px !important; }',
    '[class*="_formInputField_"] { font-family: var(--chpo-font-sans) !important; font-size: 15px !important; border-radius: 0 !important; }',
    '[class*="_formInputFieldLabel_"] { font-family: var(--chpo-font-sans) !important; color: #6c6c6c !important; }',
    '[class*="_formSubmitButton_"] { display: flex !important; align-items: center !important; justify-content: center !important; height: 56px !important; min-height: 56px !important; padding: 0 24px !important; border-radius: 0 !important; font-family: var(--chpo-font-sans) !important; font-size: 12px !important; line-height: 16px !important; font-weight: 600 !important; letter-spacing: 0.1em !important; text-transform: uppercase !important; transition: background-color 150ms ease-out !important; }',
    '[class*="_formSubmitButton_"]:hover { background-color: #fa4623 !important; filter: none !important; }',
    '[class*="_formDisclaimer_"], [class*="_formDisclaimer_"] p { font-size: 12px !important; line-height: 18px !important; color: #6c6c6c !important; }',
    '[class*="_formDisclaimer_"] a { color: #302c2b !important; }',
    '[class*="_formCloseButton_"] { box-shadow: none !important; border-radius: 0 !important; }',
    '[class*="_teaserContainer_"] { border-radius: 0 !important; background: #302c2b !important; box-shadow: none !important; padding: 14px 18px !important; gap: 12px !important; }',
    '[class*="_teaserHeading_"] { margin: 0 !important; color: #ffffff !important; font: 600 12px/16px var(--chpo-font-sans) !important; letter-spacing: 0.1em !important; text-transform: uppercase !important; }',
    '[class*="_teaserContainer_"] [class*="_formCloseButton_"] { color: #ffffff !important; background: transparent !important; }',
    '[class*="_teaserContainer_"] svg, [class*="_teaserContainer_"] svg path { fill: #ffffff !important; }'
  ].join('\n');

  function addStyle(root) {
    if (root.querySelector('style[data-chpo]')) return;
    var tag = document.createElement('style');
    tag.setAttribute('data-chpo', '');
    tag.textContent = CSS;
    root.appendChild(tag);
  }

  function style(host) {
    var root = host.shadowRoot;
    if (!root) return;
    addStyle(root);
    if (host.chpoWatched) return;
    host.chpoWatched = true;
    // Put the stylesheet back if Shopify Forms replaces its shadow contents.
    new MutationObserver(function () { addStyle(root); }).observe(root, { childList: true });
  }

  function scan() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) style(hosts[i]);
  }

  function start() {
    scan();
    // Shopify Forms loads after the page, and can re-render its root.
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
